import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Table, TableCell, TableBody, TableRow, TableHead } from '@mui/material';
import EngineRuleListItemComponent from './EngineRuleListItemComponent';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';

const EngineRuleListComponent = ({ rules, containerDispatcher, isReadOnly, validation }) => {
  const { t } = useTranslation();
  return (
    <>
      <Grid item>
        <CardNoResultsWrapper content={rules?.engineRules}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t('EngineScoring.EngineRule.Number')}</TableCell>
                <TableCell>{t('EngineScoring.EngineRule.Name')}</TableCell>
                <TableCell>{t('EngineScoring.EngineRule.Expression')}</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rules.engineRules.map((item, idx) => {
                return (
                  <EngineRuleListItemComponent
                    item={item}
                    key={idx}
                    index={idx}
                    containerDispatcher={containerDispatcher}
                    isReadOnly={isReadOnly}
                    validation={validation[idx]}
                  />
                );
              })}
            </TableBody>
          </Table>
        </CardNoResultsWrapper>
      </Grid>
    </>
  );
};

EngineRuleListComponent.propTypes = {
  rules: PropTypes.object.isRequired,
  containerDispatcher: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  validation: PropTypes.object.isRequired
};

export default EngineRuleListComponent;
